// The version of `@anshinus/anna-sdk-react` THIS BUILD INSTALLED — measured, not typed.
//
// `vite.config.ts` reads it from the resolved tarball's `package.json` and injects it as
// the compile-time constant `__SDK_VERSION__`. Surfacing the real installed version (vs. a
// literal somewhere in the UI) is the same discipline `sdk-capabilities.ts` applies to the
// SDK's behaviour: report what the artifact IS, so a version bump can never leave the
// screen quietly claiming the wrong one.
//
// `typeof __SDK_VERSION__` never throws even when the identifier is undeclared — the one
// safe reference to an undefined global — so a context that somehow lacks the define (a
// bare `tsc`, an unconfigured test runner) degrades to 'dev' instead of a ReferenceError.
declare const __SDK_VERSION__: string | undefined;

export const SDK_VERSION: string =
  typeof __SDK_VERSION__ === 'string' && __SDK_VERSION__ ? __SDK_VERSION__ : 'dev';
